import { render, staticRenderFns } from "./eliminar_gestionconvenio.vue?vue&type=template&id=7d523760&scoped=true"
import script from "./eliminar_gestionconvenio.vue?vue&type=script&lang=js"
export * from "./eliminar_gestionconvenio.vue?vue&type=script&lang=js"
import style0 from "./eliminar_gestionconvenio.vue?vue&type=style&index=0&id=7d523760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d523760",
  null
  
)

export default component.exports